import { createRouter, createWebHistory } from "vue-router";

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import("../views/LoginView.vue"),
  // },
  {
    path: "/",
    name: "home",
    component: () => import("../views/LandingView.vue"),
  },
  {
    path: "/LoginView",
    name: "LoginView",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/formmaster",
    name: "formmaster",
    component: () => import("../views/formmaster.vue"),
  },
  {
    path: "/mainlogin",
    name: "mainlogin",
    component: () => import("../views/mainlogin.vue"),
  },
  {
    path: "/employee_dashboard",
    name: "employee_dashboard",
    component: () => import("../views/employee_dashboard.vue"),
  },
  {
    path: "/account_dashboard",
    name: "account_dashboard",
    component: () => import("../views/account_dashboard.vue"),
  },
  {
    path: "/hr_dashboard",
    name: "hr_dashboard",
    component: () => import("../views/hr_dashboard.vue"),
  },
  {
    path: "/manager_dashboard",
    name: "manager_dashboard",
    component: () => import("../views/manager_dashboard.vue"),
  },

  {
    path: "/admin_dashboard",
    name: "admin_dashboard",
    component: () => import("../views/admin_dashboard.vue"),
  },
  {
    path: "/dashboard2",
    name: "dashboard2",
    component: () => import("../views/DashboardView-old.vue"),
  },
  {
    path: "/role",
    name: "role",
    component: () => import("../views/role.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/RegisterView.vue"),
  },
  {
    path: "/income-tax",
    name: "income-tax",
    component: () => import("../components/IncomeTaxDetails.vue"),
  },
  {
    path: "/add-user/:user_id",
    name: "add-user",
    component: () => import("../views/AddUserMaster.vue"),
  },
  {
    path: "/user-list",
    name: "user-list",
    component: () => import("../views/UserListView.vue"),
  },
  {
    path: "/attendanceRegularize-request",
    name: "attendanceRegularize-request",
    component: () => import("../views/AttendanceRegularizeList.vue"),
  },
  {
    path: "/mstr-attendanceRegularize-request",
    name: "mstr-attendanceRegularize-request",
    component: () => import("../views/AttendanceRegularizeListMaster.vue"),
  },
  {
    path: "/displayAttendanceRegularize-request/:request_id",
    name: "displayAttendanceRegularize-request",
    component: () => import("../views/DisplayAttendanceRegularizeView.vue"),
  },
  {
    path: "/leave-request",
    name: "leave-request",
    component: () => import("../views/EmployeeLeave.vue"),
  },
  {
    path: "/mstr-leave-request",
    name: "mstr-leave-request",
    component: () => import("../views/LeaveRequestListMaster.vue"),
  },
  {
    path: "/mstr-notification/",
    name: "mstr-notification",
    component: () => import("../views/NotificationListView.vue"),
  },
  {
    path: "/displayNotification/:notification_id",
    name: "displayNotification",
    component: () => import("../views/DisplayNotificationView.vue"),
  },
  {
    path: "/addNotification/:notification_id",
    name: "addNotification",
    component: () => import("../views/AddNotificationDetailView.vue"),
  },
  {
    path: "/pmfdue/:request_id",
    name: "pmfdue",
    component: () => import("../views/LeaveRequestView.vue"),
  },
  {
    path: "/attendance-regularise/:request_id",
    name: "attendance-regularise",
    component: () => import("../views/AttendanceRegulariseView.vue"),
  },
  {
    path: "/displayleave/:request_id",
    name: "displayleave",
    component: () => import("../views/DisplayLeaveDetailView.vue"),
  },
  {
    path: "/attendence",
    name: "attendence",
    component: () => import("../views/AttendanceDetailView.vue"),
  },
  // {
  //   path: "/personal-details",
  //   name: "personal-details",
  //   component: () => import("../views/EmployeeAddEdit.vue"),
  // },

  {
    path: "/employee-list",
    name: "employee-list",
    component: () => import("../views/EmployeeListView.vue"),
  },
  {
    path: "/paysheet",
    name: "paysheet",
    component: () => import("../views/PaySheetView.vue"),
  },
  {
    path: "/menu",
    name: "menu",
    component: () => import("../views/menu.vue"),
  },
  {
    path: "/profile-view/:employee_id",
    name: "profileview",
    component: () => import("../views/ProfileView.vue"),
  },
  {
    path: "/display-tab/:employee_id",
    name: "displayAdminTab",
    component: () => import("../components/DisplayAdminTab.vue"),
  },
  {
    path: "/pay-structure",
    name: "pay-structure",
    component: () => import("../views/PayStructuredList.vue"),
  },
  {
    path: "/define-pay-structure",
    name: "DefinePayStructure",
    component: () => import("../views/DefinePayStructure.vue"),
  },
  {
    path: "/edit-define-pay-structure/:payroll_structure_id",
    name: "EditDefinePayStructure",
    component: () => import("../views/EditDefinePayStructure.vue"),
  },
  {
    path: "/display-define-pay-structure/:payroll_structure_id",
    name: "DisplayDefinePayStructure",
    component: () => import("../views/DisplayDefinePayStructure.vue"),
  },
  {
    path: "/EmployeeDetails/:employee_id",
    name: "EmployeeDetails",
    component: () => import("../views/EmployeeDetails.vue"),
  },
  {
    path: "/holidays/:holiday_id",
    name: "holidays",
    component: () => import("../views/HolidayView.vue"),
  },
  // {
  //   path: "/company",
  //   name: "company",
  //   component: () => import("../views/CompanyView.vue"),
  // },
  // {
  //   path: "/branch",
  //   name: "branch",
  //   component: () => import("../views/BranchView.vue"),
  // },
  {
    path: "/departments-list",
    name: "departments-list",
    component: () => import("../views/DepartmentsListView.vue"),
  },
  // {
  //   path: "/departments/:department_id",
  //   name: "departments",
  //   component: () => import("../views/DepartmentView.vue"),
  // },
  {
    path: "/education_type-list",
    name: "education_type-list",
    component: () => import("../views/EducationTypeListView.vue"),
  },
  // {
  //   path: "/education_type/:education_type_id",
  //   name: "education_type",
  //   component: () => import("../views/EducationTypeView.vue"),
  // },
  {
    path: "/employment_status-list",
    name: "employment_status-list",
    component: () => import("../views/EmploymentStatusListView.vue"),
  },
  // {
  //   path: "/employment_status/:employment_status_id",
  //   name: "employment_status",
  //   component: () => import("../views/EmploymentStatusView.vue"),
  // },
  {
    path: "/leave_types-list",
    name: "leave_types-list",
    component: () => import("../views/LeaveTypesListView.vue"),
  },
  // {
  //   path: "/leave_types/:leave_type_id",
  //   name: "leave_types",
  //   component: () => import("../views/LeaveTypeView.vue"),
  // },
  {
    path: "/reimbursement/:id",
    name: "reimbursement",
    component: () => import("../views/AddReimbursementView.vue"),
  },
  {
    path: "/reimbursement-list",
    name: "reimbursement-list",
    component: () => import("../views/ReimbursementListView.vue"),
  },
  {
    path: "/displayReimbursement/:id",
    name: "displayReimbursement",
    component: () => import("../views/DisplayReimbursementDetails.vue"),
  },
  {
    path: "/mstr-reimbursement-list",
    name: "mstr-reimbursement-list",
    component: () => import("../views/ReimbursementListMasterView.vue"),
  },
  // {
  //   path: "/designation/:designation_id",
  //   name: "designation",
  //   component: () => import("../views/DesignationView.vue"),
  // },
  {
    path: "/designation-list",
    name: "designation-list",
    component: () => import("../views/DesignationListView.vue"),
  },
  // {
  //   path: "/salary",
  //   name: "salary",
  //   component: () => import("../views/SalaryView.vue"),
  // },
  // {
  //   path: "/leave",
  //   name: "leave",
  //   component: () => import("../views/LeaveView.vue"),
  // },
  {
    path: "/holiday-list",
    name: "holiday-list",
    component: () => import("../views/HolidaysListView.vue"),
  },
  {
    path: "/payroll",
    name: "payroll",
    component: () => import("../views/AddpayrollView.vue"),
  },
  {
    path: "/payslip",
    name: "payslip",
    component: () => import("../views/EmployeePayslip.vue"),
  },
  {
    path: "/reimbursement_paysheet",
    name: "reimbursement_paysheet",
    component: () => import("../views/ReimbursementPaysheet.vue"),
  },
  {
    path: "/add-reimbursement_paysheet",
    name: "add-reimbursement_paysheet",
    component: () => import("../views/AddReimbursementPaysheetview.vue"),
  },
  {
    path: "/form-24Q",
    name: "form-24Q",
    component: () => import("../components/IncomeTaxDetails24Q.vue"),
  },
  {
    path: "/leave-carry-forward",
    name: "leave-carry-forward",
    component: () => import("../views/LeaveCarryForward.vue"),
  },
  {
    path: "/display-leave-carry/:employee_id",
    name: "display-leave-carry",
    component: () => import("../views/DisplayLeaveCarryForword.vue"),
  },
  {
    path: "/qualification-list",
    name: "qualification-list",
    component: () => import("../views/QualificationListView.vue"),
  },
  // {
  //   path: "/qualification/:qualification_id",
  //   name: "qualification",
  //   component: () => import("../views/QualificationView.vue"),
  // },
  {
    path: "/payroll-deduction-list",
    name: "payroll-deduction-list",
    component: () => import("../views/PayrollDeductionItemMasterList.vue"),
  },
  // {
  //   path: "/payroll-deduction/:deduction_item_id",
  //   name: "payroll-deduction",
  //   component: () => import("../views/PayrollDeductionItemView.vue"),
  // },
  {
    path: "/payroll-earning-list",
    name: "payroll-earning-list",
    component: () => import("../views/PayrollEarningItemMasterList.vue"),
  },
  // {
  //   path: "/payroll-earning/:earning_item_id",
  //   name: "payroll-earning",
  //   component: () => import("../views/PayrollEarningItemView.vue"),
  // },
  {
    path: "/process-type-list",
    name: "process-type-list",
    component: () => import("../views/ProcessTypeList.vue"),
  },
  {
    path: "/rejection-reason-list",
    name: "rejection-reason-list",
    component: () => import("../views/RejectionReasonList.vue"),
  },
  {
    path: "/reimbursement-type-list",
    name: "reimbursement-type-list",
    component: () => import("../views/ReimbursementTypeList.vue"),
  },
  {
    path: "/location-list",
    name: "location-list",
    component: () => import("../views/LocationListView.vue"),
  },
  {
    path: "/exit-reason-list",
    name: "exit-reason-list",
    component: () => import("../views/ExitReasonListView.vue"),
  },
  {
    path: "/attendanceRegularize-reason-list",
    name: "attendanceRegularize-reason-list",
    component: () => import("../views/AttendanceRegularizeReasonlist.vue"),
  },
  {
    path: "/taxSlab-list",
    name: "taxSlab-list",
    component: () => import("../views/TaxSlabListView.vue"),
  },
  {
    path: "/annualYearLeave-list",
    name: "annualYearLeave-list",
    component: () => import("../views/AnnualYearLeaveList.vue"),
  },
  {
    path: "/view-attendance",
    name: "view-attendance",
    component: () => import("../views/ViewAttendance.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
